// extracted by mini-css-extract-plugin
export default {"mainCont":"ActiveSimInfo_mainCont__LSTl3","btnCont":"ActiveSimInfo_btnCont__5XfEh"};